import { TranslationType } from '../types';

export const coverageTypeMapping = (t: TranslationType) => {
  const mapping = {
    'full-amortization': t('full-amortization'),
    'term-insurance': t('term-insurance')
  };
  return mapping;
};
